const pluginTabs = (function () {
	const init = () => {
		const filters = document.querySelectorAll('.m-apis__filter-item');
		const dropdown = document.querySelector('.m-apis__filter-mobile select');

		dropdown.addEventListener('change', function () {
			filterTabs(dropdown.value);
		});

		[].map.call(filters, (filter) => {
			filter.addEventListener('click', () => filterTabs(filter.dataset.category));
		});
	};

	function filterTabs(data) {
		const tabs = document.querySelectorAll('.m-apis__tab');
		const filters = document.querySelectorAll('.m-apis__filter-item');

		[].map.call(filters, (filter) => {
			if (filter.classList.contains('m-apis__filter-item--active')) {
				filter.classList.remove('m-apis__filter-item--active');
			}

			if (filter.dataset.category == data) {
				filter.classList.add('m-apis__filter-item--active');
			}
		});

		[].map.call(tabs, (tab) => {
			if (tab.classList.contains('m-apis__tab--active')) {
				tab.classList.remove('m-apis__tab--active');
			}

			if (tab.dataset.category == data) {
				tab.classList.add('m-apis__tab--active');
			}
		});
	}

	return {
		init,
	};
})();

if (document.querySelectorAll('.m-apis__tab').length) {
	pluginTabs.init();
}
